import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { Label } from '@/components/ui/label'

interface Props {
    id: string
    value: string
    onChange: (value: string) => void
}

const OPTIONS: [string, string][] = [
    ['yes', 'Yes'],
    ['no', 'No'],
]

export default function YesNoInput({ id, value, onChange }: Props) {
    return (
        <RadioGroup value={value} onValueChange={onChange} className="flex flex-wrap gap-3">
            {OPTIONS.map(([val, label]) => (
                <Label
                    key={val}
                    htmlFor={`${id}_${val}`}
                    className="flex w-32 cursor-pointer items-center gap-2.5 rounded-lg border bg-card px-4 py-2.5 text-sm font-normal transition-colors hover:bg-muted has-[[data-state=checked]]:border-primary has-[[data-state=checked]]:bg-primary/5 has-[[data-state=checked]]:text-foreground"
                >
                    <RadioGroupItem id={`${id}_${val}`} value={val} />
                    {label}
                </Label>
            ))}
        </RadioGroup>
    )
}
